import React, { useState } from "react";

function TimeStepSelector({ width, dataUnit, onValuesChange }) {
  const [deltaT, setDeltaT] = useState("");
  const [deltaTUnit, setDeltaTUnit] = useState("s");
  const [stepSize, setStepSize] = useState("");
  const [stepSizeUnit, setStepSizeUnit] = useState("s");

  // ✅ Handle updates safely
  const handleUpdate = () => {
    const parsedDeltaT = parseFloat(deltaT.replace(",", "."));
    const parsedStepSize = parseFloat(stepSize.replace(",", "."));

    if (isNaN(parsedDeltaT) || isNaN(parsedStepSize)) {
      return; // Do nothing if invalid input
    }

    // ✅ Send **raw values** and **unit selections** to SelectPage
    onValuesChange({
      deltaT: parsedDeltaT, // ✅ No conversion
      stepSize: parsedStepSize, // ✅ No conversion
      deltaTUnit, // ✅ Just pass the selected unit
      stepSizeUnit, // ✅ Just pass the selected unit
    });
  };

  return (
    <div style={{ ...styles.container, width: `${width}px` }}>
      <h3 style={styles.title}>Set Time Parameters</h3>

      {/* ✅ DeltaT Field */}
      <div style={styles.inputRow}>
        <div style={styles.labelContainer}>
          <span style={styles.label}>ΔT ⓘ</span>
        </div>
        <input
          type="text"
          value={deltaT}
          onChange={(e) => setDeltaT(e.target.value)}
          onBlur={handleUpdate}
          placeholder="Enter deltaT"
          style={styles.input}
        />
        <select
          value={deltaTUnit}
          onChange={(e) => setDeltaTUnit(e.target.value)}
          onBlur={handleUpdate}
          style={styles.dropdown}
        >
          {["s", "m", "h", "d"].map((unit) => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
      </div>

      {/* ✅ StepSize Field */}
      <div style={styles.inputRow}>
        <div style={styles.labelContainer}>
          <span style={styles.label}>Step Size ⓘ</span>
        </div>
        <input
          type="text"
          value={stepSize}
          onChange={(e) => setStepSize(e.target.value)}
          onBlur={handleUpdate}
          placeholder="Enter step size"
          style={styles.input}
        />
        <select
          value={stepSizeUnit}
          onChange={(e) => setStepSizeUnit(e.target.value)}
          onBlur={handleUpdate}
          style={styles.dropdown}
        >
          {["s", "m", "h", "d"].map((unit) => (
            <option key={unit} value={unit}>{unit}</option>
          ))}
        </select>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "15px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "8px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#222",
    marginBottom: "8px",
  },
  inputRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    width: "100%",
    justifyContent: "center",
  },
  labelContainer: {
    minWidth: "100px", // Ensures labels align properly
    textAlign: "right",
    paddingRight: "5px",
    position: "relative", // Required for superscript positioning
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    display: "inline-flex",
    alignItems: "center",
    cursor: "help", // ✅ Cursor changes to help on hover
  },
  infoIcon: {
    fontSize: "10px", // ✅ Smaller font for superscript effect
    verticalAlign: "super", // ✅ Moves it upwards like an exponent
    marginLeft: "2px", // ✅ Slight spacing from text
  },
  input: {
    width: "50%",
    padding: "5px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #aaa",
    textAlign: "center",
  },
  dropdown: {
    padding: "5px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #aaa",
    textAlign: "center",
  },
};

export default TimeStepSelector;
